<div class="page-breadcrumb">
    <div class="row">
        <div class="col-12 d-flex no-block align-items-center">
            <div class="mr-auto text-right">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><i class="fa fa-home"></i>&nbsp;<a routerLink="/Home/Dashboard"
                                (click)="ChangeParentPath('Dashboard')">Home</a></li>
                        <li *ngFor="let bread of Breads; let i = index" class="breadcrumb-item" aria-current="page">
                            {{bread.label}}</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</div>